import React from 'react';
import { observer } from 'mobx-react';
import { BaasicTableSettingsTemplate } from 'themes/components';

const BaasicTableSettings = props => {
	return <BaasicTableSettingsTemplate {...props} />;
};

export default observer(BaasicTableSettings);



// WEBPACK FOOTER //
// ./src/core/components/table/BaasicTableSettings.jsx